import { useQuery } from '@tanstack/react-query';

import { getOnboarding } from '../../api/endpoints/onboarding';
import { isCoach, isOwner } from '../../auth/roles';
import { usePermissions } from '../../auth/usePermissions';
import { useSession } from '../../auth/useSession';
import { modeForCategory } from '../../lib/mode';
import { useBusiness } from '../../lib/useBusiness';
import { useFeatures } from '../../lib/useFeatures';
import { useTools } from '../../lib/useTools';
import { buildNavModel, type NavModel } from './navModel';

const ONBOARDING_QUERY_KEY = ['business-onboarding'];

/** The folders and settings the signed-in person may open, from the same rules the sidebar uses. */
export function useNavModel(): NavModel {
  const { session } = useSession();
  const { can } = usePermissions();
  const business = useBusiness();
  const { features } = useFeatures();
  const { tools, category } = useTools();
  const owner = isOwner(session?.role);
  const onboardingQuery = useQuery({ queryKey: ONBOARDING_QUERY_KEY, queryFn: getOnboarding, enabled: owner });
  return buildNavModel({
    portalMode: business ? modeForCategory(business.category) : 'services',
    ...(category ? { category } : {}),
    tools,
    // Unknown while the business loads; a loaded business with no plan reads as Base, like the server.
    plan: business ? (business.plan ?? 'base') : undefined,
    owner,
    coach: isCoach(session),
    can,
    onboardingDraft: onboardingQuery.data?.state === 'draft',
    features,
  });
}
